module.exports = __webpack_public_path__ + "static/media/hamburger.ba8156a7.svg";